import type {
  BagCalculatorApiResponse,
  BagCalculatorErrorResponse,
  BagCalculatorRequest,
  BagCalculatorResponse,
} from "./bag-calculator-types";
import { queryOptions } from "@tanstack/react-query";

const BAG_CALCULATOR_KEYS = () => ["bag-calculator"] as const;

export class BagCalculatorError extends Error {}

const isBagCalculatorError = (
  response: BagCalculatorApiResponse,
): response is BagCalculatorErrorResponse =>
  "error" in response ||
  "validationErrors" in response ||
  (response as BagCalculatorErrorResponse).status?.transactionStatus ===
    "error";

export const getBaggageFees = async (
  request: BagCalculatorRequest,
  apiUrl: string,
  subscriptionKey: string,
): Promise<BagCalculatorResponse> => {
  const url = `${apiUrl}/baggage/baggageFees`;

  const response = await fetch(url, {
    body: JSON.stringify(request),
    headers: {
      "Content-Type": "application/json",
      "ocp-apim-subscription-key": subscriptionKey,
    },
    method: "POST",
  });

  if (!response.ok) {
    throw new BagCalculatorError(
      `HTTP ${response.status.toString()}: ${response.statusText}`,
    );
  }

  const data = (await response.json()) as BagCalculatorApiResponse;

  if (isBagCalculatorError(data)) {
    const errorMessage =
      data.error?.message ??
      data.validationErrors?.[0]?.message ??
      "Unknown bag calculator error";
    throw new BagCalculatorError(errorMessage);
  }

  return data;
};
export const baggageFeesOptions = (
  request: BagCalculatorRequest,
  apiUrl: string,
  subscriptionKey: string,
) =>
  queryOptions({
    queryFn: () => getBaggageFees(request, apiUrl, subscriptionKey),
    queryKey: [
      ...BAG_CALCULATOR_KEYS(),
      "baggage-fees",
      request.origin,
      request.destination,
      request.departureDate,
      request.fareClass,
    ] as const,
  });
